import { ModuleType } from "configs/permissions"
import { selectUserRole } from "stores/auth/authSlice"
import { selectRoleDetails } from "stores/ui/uiSlice"

import { useAppSelector } from "./store/hooks"

const useModulePermission = (module: ModuleType) => {
  const userRole = useAppSelector(selectUserRole)
  const roleData = useAppSelector(selectRoleDetails)

  if (!userRole || !roleData || roleData.length === 0) {
    return {
      hasAccessToModule: undefined,
      permitedActions: [],
    }
  }

  const hasAccess = roleData
    ?.find((user) => user.role === userRole)
    ?.rule?.find((i) => i.module === module)
  if (hasAccess) {
    return {
      hasAccessToModule: true,
      permitedActions: hasAccess.action,
    }
  }

  return {
    hasAccessToModule: false,
    permitedActions: [],
  }
}

export default useModulePermission
